import { render, staticRenderFns } from "./LiveAccountContactClientView.vue?vue&type=template&id=d13bc3b8&scoped=true"
import script from "./LiveAccountContactClientView.vue?vue&type=script&lang=js"
export * from "./LiveAccountContactClientView.vue?vue&type=script&lang=js"
import style0 from "./LiveAccountContactClientView.vue?vue&type=style&index=0&id=d13bc3b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13bc3b8",
  null
  
)

export default component.exports